// (window.FaqAccordion = function (Behaviors) {

//   "use strict";
  
//   function FaqAccordion(elem) {
//     Behaviors.init(FaqAccordion, this, arguments);
//     this.accordion = this.$elem[0];
//     this.items = this.accordion.querySelectorAll('.accordion__title');
//     this.items.forEach(item => {
//       item.addEventListener('click', this.slideAnim.bind(this));
//     })
//   }

//   Behaviors.inherit(FaqAccordion, Behaviors.Behavior);
//   FaqAccordion.QUERY = ".accordion__list";

//   FaqAccordion.prototype.slideAnim = function(e) {
//     this.el = e.currentTarget;
//     this.body = this.el.parentElement.querySelector('.accordion__body');
//     this.active = this.el.closest('.accordion__list').querySelector('.accordion__item.accordion__item--active');
//     if (this.active) {
//       this.active.classList.remove('accordion__item--animate');
//       this.active.querySelector('.accordion__body').style.height = "0px";
//       this.active.querySelector('.accordion__body').addEventListener('transitionend', () => {
//         this.active.classList.remove('accordion__item--active')
//       }, { once: true })
//     }
//     if (!this.el.parentElement.classList.contains('accordion__item--active')) {
//       this.el.parentElement.classList.add('accordion__item--active', 'accordion__item--animate')
//       this.body.style.height = 'auto';
//       this.height = this.body.offsetHeight + 'px';
//       this.body.style.height = "0px";
//       setTimeout(() => {
//         this.body.style.height = this.height;
//       }, 0);
//     } else {
//       this.el.parentElement.classList.remove('accordion__item--animate');
//       this.body.style.height = "0px";
//       this.body.addEventListener('transitionend', () => {
//         this.el.parentElement.classList.remove('accordion__item--active');
//       }, { once: true })
//     }
//   }

//   Behaviors.register_behavior(FaqAccordion);

//   return FaqAccordion;

//   }(window.Behaviors));